import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import ClubCiergeLab from "./pages/ClubCiergeLab";
import ReceiptPublic from "./pages/ReceiptPublic";
import HorizonFit from "./pages/HorizonFit";
import FitIndex from "./pages/FitIndex";
import EsrcFit from "./pages/EsrcFit";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/labs/clubcierge" element={<ClubCiergeLab />} />
          <Route path="/r/:hash" element={<ReceiptPublic />} />
          <Route path="/fit" element={<FitIndex />} />
          <Route path="/fit/horizon" element={<HorizonFit />} />
          <Route
            path="/fit/esrc-future-data-services"
            element={<EsrcFit />}
          />
          {/* Legacy redirect — preserve any external links to the old URL */}
          <Route
            path="/horizon-fit"
            element={<Navigate to="/fit/horizon" replace />}
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
